<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Rules
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="uploadDialogSwitch = true" :disabled="!$can('update', 'MaintenanceRecord')"><v-icon small class="mr-2">fa-file-excel</v-icon> Bulk Upload Excel</v-btn>

                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Rule')"><v-icon class="mr-2" small>fa-plus</v-icon> Add Record</v-btn>
                    <rule-record-dialog v-model="dialog" :item="editedItem" :parameter="parameter" v-on:doreload="refresh()" v-on:refreshpoints="refreshpoints()"></rule-record-dialog>
                    <maintenance-upload-dialog
                            v-model="uploadDialogSwitch"
                            v-if="uploadDialogSwitch"
                            endpoint="/rule/upload/"
                            has-remove-switch
                            v-on:doreload="refresh()"
                            title="Rule Creation">
                    </maintenance-upload-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="rules"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.desc }}</td>
        <td class="text-xs-left">{{ props.item.equipment_group }}</td>
        <td class="text-xs-left">

            <span v-if="props.item.on">Chiller On</span>
            <span v-if="props.item.on===false">Chiller Off</span>
            <span v-if="props.item.on===null">Anytime</span>
        </td>
        <td class="text-xs-left">{{ props.item.topic }}</td>
        <td class="text-xs-left">{{ props.item.rule }}</td>
        <td class="text-xs-left">{{ props.item.value }}</td>
        <td class="text-xs-left">{{ props.item.cost }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'Rule') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'Rule') &&  deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getRule, deleteRule, getParameter} from '../helper'
import RuleRecordDialog from '../components/rule/RuleRecordDialog'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";

export default {
    name: 'Rules',
  components: { RuleRecordDialog,MaintenanceUploadDialog },
  data: () => ({
      dialog: false,
      uploadDialogSwitch: false,
      headers: [
        {
          text: 'Title ',
          align: 'left',
          sortable: true,
          value: 'title'
        },{
          text: 'Description ',
          align: 'left',
          sortable: true,
          value: 'desc'
        },
        { text: 'Applicable Group(s) ', value: 'equipment_group' },
        { text: 'Rule Active when ', value: 'on' },
        { text: 'Topic ', value: 'topic', sortable: true },
        { text: 'Rule ', value: 'rule', sortable: false },
        { text: 'Value ', value: 'value', sortable: false},
        { text: 'Cost ', value: 'cost', sortable: false },
        { text: 'Action ', sortable: false },
      ],
      parameter:[],
      rules: [
        {
          desc: 'CHWS too cold',
          equipment_group: 'Chillers',
          'rule': 'df["CHWS_Temp"]<6',
          'on_only': true,
          'value': '1',
          'cost': '0'
        },
        {
          desc: 'CHWR too warm',
          equipment_group: 'Chillers',
          'rule': 'df["CHWR_Temp"]>20',
          'on_only': true,
          'value': '1',
          'cost': '0'
        },
        {
          desc: 'CHW Return Temp is Higher than CHW Supply',
          equipment_group: 'Chillers',
          'rule': 'df["CHWR_Temp"] - df["CHWS_Temp"]<0',
          'on_only': true,
          'value': '1',
          'cost': '0'
        }

      ],
      editedIndex: -1,
      editedItem: {
      },
    }),
  watch: {
    dialog () {
      this.refresh()
    }
  },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.rules.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.rules.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.rules.splice(index, 1)
          await deleteRule({
            'rule_id': item.rule_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.rules[this.editedIndex], this.editedItem)
        } else {
          this.rules.push(this.editedItem)
        }
        this.close()
      },
        async refreshpoints(){
            let dfp = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.parameter = dfp['result']
        },
        async refresh() {
            let df = await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            let dfp = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.rules = df['result']
            this.parameter = dfp['result']
        }
    }
  }
</script>

<style scoped>

</style>
